import { operationalProjects } from '../../data/operationalProjects';
import Button from '../common/Button';
import Card from '../common/Card';
import SectionHeader from '../common/SectionHeader';

function OperationalProjectsSection() {
  return (
    <section className="section projects-section" id="projects">
      <div className="container">
        <SectionHeader
          eyebrow="Operational Projects"
          title="Operational projects"
          description="FactorStreet operates and supports multiple projects across software development, education, SaaS, and digital learning."
        />

        <div className="project-grid">
          {operationalProjects.map((project) => (
            <Card className="project-card" key={project.slug}>
              <div className="project-card__topline">
                <span>{project.category}</span>
                <strong>{project.status}</strong>
              </div>
              <h3>{project.name}</h3>
              <p>{project.description}</p>
              <ul>
                {project.keyPoints.map((point) => (
                  <li key={point}>{point}</li>
                ))}
              </ul>
              <div className="project-card-actions">
                <Button href={project.url} rel="noopener noreferrer" target="_blank" variant="primary">
                  Visit Website
                </Button>
                <span className="project-card-url">{project.displayUrl}</span>
              </div>
            </Card>
          ))}
        </div>
      </div>
    </section>
  );
}

export default OperationalProjectsSection;
